export function isPageTranslated() {
    const cls = document.documentElement.classList;
    return cls.contains('translated-ltr') || cls.contains('translated-rtl');
}
/** Self-contained runtime: its one helper is passed explicitly for serialization. */
function installTranslateDomGuardRuntime(onGuardTriggered, pageTranslated) {
    if (typeof Node !== 'function' || !Node.prototype)
        return;
    const current = Node.prototype.removeChild;
    // Both names were shipped before consolidation. Honor either one so an
    // older inline script or a reinjected client cannot double-wrap this page.
    if (current.__oqaTranslateDomGuard || current.__oqTranslateDomGuard)
        return;
    let reported = false;
    const report = (operation) => {
        if (reported)
            return;
        reported = true;
        try {
            onGuardTriggered?.(operation, pageTranslated());
        }
        catch { /* Telemetry must never break the repair path. */ }
    };
    const originalRemoveChild = Node.prototype.removeChild;
    function guardedRemoveChild(child) {
        if (child && child.parentNode !== this) {
            report('removeChild');
            return child;
        }
        return originalRemoveChild.call(this, child);
    }
    const originalInsertBefore = Node.prototype.insertBefore;
    function guardedInsertBefore(newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            report('insertBefore');
            return originalInsertBefore.call(this, newNode, null);
        }
        return originalInsertBefore.call(this, newNode, referenceNode);
    }
    const installed = guardedRemoveChild;
    installed.__oqaTranslateDomGuard = true;
    installed.__oqTranslateDomGuard = true;
    Node.prototype.removeChild = guardedRemoveChild;
    Node.prototype.insertBefore = guardedInsertBefore;
}
export function installTranslateDomGuards(onGuardTriggered) {
    installTranslateDomGuardRuntime(onGuardTriggered, isPageTranslated);
}
/** Trusted, self-contained callback only; no page data is interpolated here. */
export function translateDomGuardScript(onGuardTriggered) {
    return `;(${installTranslateDomGuardRuntime.toString()})(${onGuardTriggered?.toString() ?? 'undefined'}, ${isPageTranslated.toString()});`;
}
//# sourceMappingURL=translateDomGuards.js.map